import { METRICS, PRINCIPLES } from '@/mocks/data';

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 overflow-hidden bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* left */}
          <div className="lg:col-span-7">
            <p className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>
              关于我们
            </p>
            <h2 className="font-heading text-2xl font-black leading-snug text-foreground-950 text-balance md:text-[34px]">
              我们做一件事:让全网热点
              <span className="text-primary-600">更早</span>、
              <span className="text-accent-600">更清楚</span>地出现在你面前
            </h2>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              51黑瓜速递是一个专注全网热点聚合的资讯频道。我们不生产争议,而是把散落在不同平台、不同角落的热议话题汇聚起来,帮你在最短时间里抓住当天真正值得关注的瓜田风向。
            </p>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              从热点爆发、话题发酵到多方声音,我们用一条条快讯和一篇篇特辑,串联起事件的时间线。无论你追娱乐、刷科技,还是关心社会民生与网络文化,都能在这里按图索骥、快速上手,真正实现吃瓜不迷路。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {PRINCIPLES.map((p) => (
                <div key={p.title} className="flex gap-3 rounded-xl border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-700">
                    <i className={p.icon}></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* right accent panel */}
          <div className="lg:col-span-5">
            <div className="flex h-full flex-col overflow-hidden rounded-2xl bg-accent-500 p-6 text-foreground-950 md:p-7">
              <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl bg-accent-400/40">
                {METRICS.map((m) => (
                  <div key={m.label} className="flex flex-col bg-accent-500 px-4 py-5">
                    <span className="font-heading text-2xl font-black tabular-nums md:text-3xl">{m.value}</span>
                    <span className="mt-1 text-xs font-medium text-accent-900">{m.label}</span>
                  </div>
                ))}
              </div>

              <figure className="mt-6 flex flex-1 flex-col rounded-xl bg-accent-600/25 p-5">
                <i className="ri-double-quotes-l text-3xl text-accent-800"></i>
                <blockquote className="mt-2 text-sm font-medium leading-relaxed text-accent-950">
                  追热点最怕的是后知后觉。在 51黑瓜速递,重要话题几乎当天就能看到整理好的时间线,省下我到处刷的时间,真的吃瓜不迷路。
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-950 text-xs font-bold text-accent-100">读</span>
                  <span className="text-sm">
                    <span className="block font-bold">一位常驻读者</span>
                    <span className="block text-xs text-accent-800">已连续阅读 236 天</span>
                  </span>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}